// Array of field configurations

export const breadcrumbItems = [
    { label: "campaigns Products", link: "/auth/Campaign-Product" },
];
